import { ThemeInterface } from '@westwing/ui-kit/Theme';
import styled, { ThemeProps } from 'styled-components';
import { fromBreakpoint, TABLET } from '../../../../mediaqueries';

interface BadgeProps extends ThemeProps<ThemeInterface> {
    isCenterPlaced?: boolean;
}
export const Badge = styled.div<BadgeProps>`
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 96px;
    height: 96px;
    border: 4px solid white;
    background: ${(props: BadgeProps) => props.theme.colors.turquoise90};
    color: white;
    text-align: center;
    right: -48px;
    top: ${(props: BadgeProps) => (props.isCenterPlaced ? 'calc(50% - 48px)' : '36px')};
    border-radius: 50%;
    padding: 4px;
    font-size: 14px;
    z-index: 1;

    ${fromBreakpoint[TABLET]`
        display: flex;
    `}
`;
